import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { PhotoRevealsResource } from '../../../core/resources/photoReveals.resource';
import { IApiPhotoRevealsResult } from '../../../models/photoReveals';
import { photoRevealsNormalizer } from './photoReveals.normalizer';

export const PAGE_SIZE = 10;

export function* getPhotoReveals(
  pageNumber: number,
  pageSize: number = PAGE_SIZE
) {
  const accountId: string = yield select(selectAccountId);
  const response: IApiPhotoRevealsResult = yield call(
    PhotoRevealsResource.getPhotoReveals,
    accountId,
    pageNumber,
    pageSize
  );

  return photoRevealsNormalizer(response);
}

export function* postPhotoReveal({
  receiverId,
  messageId,
  isPhotoRequestAccepted,
}: {
  receiverId: string;
  messageId: string;
  isPhotoRequestAccepted: boolean;
}) {
  yield call(
    PhotoRevealsResource.postPhotoReveal,
    receiverId,
    messageId,
    isPhotoRequestAccepted
  );
}
